import { render, staticRenderFns } from "./ViewFrame.vue?vue&type=template&id=62fd1936"
import script from "./ViewFrame.vue?vue&type=script&lang=js"
export * from "./ViewFrame.vue?vue&type=script&lang=js"
import style0 from "./ViewFrame.vue?vue&type=style&index=0&id=62fd1936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports